import { getPdfReportsRequest } from 'api/Data/api';
import { PaginatedPdfReports, PdfReport, PdfReportsFilterParams } from 'api/Data/types';
import getErrorFromPromiseReason from 'app/helpers/getErrorFromPromiseReason';

import { useCallback, useState } from 'react';
import { message } from 'antd';

const usePdfReports = () => {
  const [ isLoading, setIsLoading ] = useState<boolean>(false);
  const [ response, setResponse ] = useState<PaginatedPdfReports>({ count: 0, results: [] });

  const fetchPdfReports = useCallback((
    orderId: string,
    page: number,
    pageSize: number,
    filter: PdfReportsFilterParams,
    abortController?: AbortController,
  ) => {
    setIsLoading(true);
    getPdfReportsRequest(orderId, page, pageSize, filter, abortController)
      .then(({ data }) => {
        setResponse(data);
      })
      .catch((reason) => {
        if (!abortController?.signal.aborted) {
          message.error(getErrorFromPromiseReason(reason));
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);
  
  const updateReport = useCallback((reportId: string, updatedFields: Partial<PdfReport>) => {
    setResponse(prev => ({
      ...prev,
      results: prev.results.map(report => (report.id === reportId ? { ...report, ...updatedFields } : report)),
    }));
  }, []);

  return { isLoading, fetchPdfReports, response, updateReport };
};

export default usePdfReports;
